import React, { Component } from 'react';
import 'react-phone-number-input/style.css'
import {AppBar, Toolbar, Typography, Paper, CardContent, TextField, CardActions, Button, CircularProgress, List, ListItem, ListItemIcon} from '@material-ui/core';

class VerifyContainer extends Component {
    constructor() {
        super();
        this.state = {number: ""};
    }

    setNumber(value) {this.setState({number: value})}
    render() {
        return <React.Fragment>
        <CardContent>
            <Typography variant="headline">Let's get started.</Typography>
            <div className="spacer"></div>
            We'll need your phone number to continue.
            <div className="spacer"></div>
            <TextField label="Phone Number" />
            
        </CardContent>
        
        <CardActions>
            <Button variant="contained" color="primary" onClick={this.props.done}>Continue</Button>
        </CardActions>
        </React.Fragment>
    }
}

export default VerifyContainer;